/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DataActionRecipientCondition from 'cio/app-models/data-action/recipient-condition';
import {
  DataActionAutocompleteValuesContainer,
  DataActionConditionType,
  DataActionTriggerAttributeDropdownItem,
} from 'cio/utils/campaigns/data-action';
import { Preview } from 'cio/utils/previews';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

interface RecipientSectionArgs {
  recipientCondition: DataActionRecipientCondition;
  canMatchRecipientTitle: string;
  mustMatchRecipientTitle: string;
  editableEntity: ComposerEditableEntity;
  autocompleteValues: DataActionAutocompleteValuesContainer;
  onFocusRecipientInput: () => unknown;
  onBlurRecipientInput: () => unknown;
  updateHighlight: (highlight: DataActionTriggerAttributeDropdownItem | null) => unknown;
  supportedConditionTypes: DataActionConditionType[];
  isLoadingAsyncAutocompleteValues: boolean;
  liquidFieldFocusIn: (fieldName: string, index?: number) => unknown;
  liquidFieldFocusOut: () => unknown;
  showRecipientErrors?: boolean;
  preview?: Preview;
  isPreviewLoading?: boolean;
  trackPreviewErrors?: (
    element: HTMLElement,
    [errors]: [{ field: string; label: string; errors: string[] }[]],
  ) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class RecipientSectionComponent extends Component<RecipientSectionArgs> {}
